import './App.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {HoraeDataGrande} from './DataEx.js'; 
import {SvgEnviar} from './Svg.js';


function LoginEsquceuSenha() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault(); // Evita o comportamento padrão do formulário
    try {
      const response = await fetch('http://www.criar.com.br:3000/esqueceu/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }), // Dados enviados ao backend
      });
      if (response.status === 200) {
        const data = await response.text();
        alert(data);
        navigate('/area');
    }
    } catch (error) {
      alert('Erro na autenticação:', error);
    }
  };





  return (
    <div>
      
<div class="areabox">
<div class="DateeHora"><HoraeDataGrande/> </div>
  <h1>Área Restrita</h1>
  <div class='row'>
    <div class='col-p'>
      <div class='card1'>
        
      </div>
    </div>

    <div class='col-4'>
      <div class='card1'>
      <h2> Esquceu a Senha?</h2>

      <form onSubmit={handleSubmit}>

<div class="form-group">
<label for="email" class="form-control">Email:</label><br/>
<input type="email" id="email" placeholder="Entre com o email" value={email} onChange={(e) => setEmail(e.target.value)} required 
  size="25"  class="form-controli"   name="email" /><br/><br/>

<button type="submit" class="botaocinsa"><SvgEnviar/><br/>Lenbrar</button><br/><br/>
</div>

</form>


      </div>
    </div>


  </div>
</div>  


    </div>
  );
}

export default LoginEsquceuSenha;